import { motion, useReducedMotion } from "framer-motion";
import { Phone, MapPin, MessageSquare, ShieldCheck, Activity } from "lucide-react";

const rows = [
  { icon: Phone, label: "Chiamate", value: "24 oggi" },
  { icon: MessageSquare, label: "Messaggi", value: "153" },
  { icon: MapPin, label: "Posizione GPS", value: "In tempo reale" },
  { icon: Activity, label: "App attive", value: "12" },
];

export const PhoneMockup = () => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 30, rotate: -2 }}
      animate={{ opacity: 1, y: 0, rotate: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative mx-auto w-[260px] sm:w-[300px]"
    >
      <div className="relative rounded-[2.6rem] border-[10px] border-foreground/85 bg-card p-3 shadow-2xl glow-strong">
        <div className="absolute left-1/2 top-3 h-5 w-24 -translate-x-1/2 rounded-full bg-foreground/85" />
        <div className="rounded-[1.8rem] overflow-hidden bg-secondary/60 p-4 pt-9">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                <ShieldCheck className="h-4 w-4" />
              </span>
              <div>
                <p className="text-[11px] font-semibold leading-none">Pannello Cloud</p>
                <p className="text-[9px] text-muted-foreground">Dispositivo online</p>
              </div>
            </div>
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-500 animate-pulse" />
          </div>

          <div className="mt-4 space-y-2.5">
            {rows.map((r, i) => (
              <motion.div
                key={r.label}
                initial={reduce ? { opacity: 0 } : { opacity: 0, x: 14 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 + i * 0.12, duration: 0.45 }}
                className="flex items-center justify-between rounded-xl bg-card border border-border px-3 py-2.5 glow"
              >
                <span className="flex items-center gap-2 text-[11px] font-medium">
                  <r.icon className="h-3.5 w-3.5 text-accent" />
                  {r.label}
                </span>
                <span className="text-[10px] text-muted-foreground">{r.value}</span>
              </motion.div>
            ))}
          </div>

          <div className="mt-4 rounded-xl bg-primary/10 border border-primary/20 px-3 py-2.5">
            <p className="text-[10px] font-medium text-foreground">Report giornaliero pronto</p>
            <p className="text-[9px] text-muted-foreground">Inviato via email alle 08:00</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
